'use strict';
const angular = require('angular');
import { extendedCRUDMethods } from "./extendedCRUDMethods";

export default function OfferResource($resource) {
    'ngInject';
    return $resource('/api/offers/:id', { id: '@id' }, extendedCRUDMethods);
}



// WEBPACK FOOTER //
// ./client/components/resources/offer.resource.ts